module.exports = __webpack_public_path__ + "ea04e5687f316fde4b01a5fb20b28120.png";